import { jsx as _jsx } from "react/jsx-runtime";
import { getTiposDependencias } from './tipos_dependencias_service';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 500 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export function TiposDependenciasListar() {
    return (_jsx(GridBase, { pagina: PAGINAS.TIPOS_DEPENDENCIAS, paginaPermissao: FUNCIONALIDADES.TIPOS_DEPENDENCIAS, rota: ROUTES.TIPOS_DEPENDENCIAS, fetchData: function (str, _filter, pag) { return getTiposDependencias(str, pag); }, columns: COLUNAS }));
}
export default TiposDependenciasListar;
